import { useContext, useMemo } from "react";
import { usePopoverLegacy, PopoverLegacyProps } from "./usePopoverLegacy";
import { PopoverLegacyContext } from "./usePopoverLegacyContext";
import { PopoverLegacyTrigger } from "./PopoverLegacyTrigger";
import { PopoverLegacyContent } from "./PopoverLegacyContent";
import { PopoverLegacyClose } from "./PopoverLegacyClose";
import { ThemeProviderContext } from "../../providers";
import { PopoverLegacyButton } from "./PopoverLegacyButton";

export function PopoverLegacyElement({
  children,
  modal,
  ...restOptions
}: PopoverLegacyProps) {
  const popover = usePopoverLegacy({ modal, ...restOptions });
  const { theme, mode = "light" } = useContext(ThemeProviderContext);
  const value = useMemo(
    () => ({ ...popover, theme, mode }),
    [mode, popover, theme],
  );
  return (
    <PopoverLegacyContext.Provider value={value}>
      {children}
    </PopoverLegacyContext.Provider>
  );
}

export const PopoverLegacy = Object.assign(PopoverLegacyElement, {
  Trigger: PopoverLegacyTrigger,
  Close: PopoverLegacyClose,
  Content: PopoverLegacyContent,
  Button: PopoverLegacyButton,
});
